<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UGZtV1/tc-custom/9780795352317.jpg?1721057644868" alt="This image is the cover for the book Voice from the Attic"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Voice from the Attic
      </h1>
      <p class="bookDescription body article font2">
        <b>A collection of essays “filled with pleasantly rambling opinions about everything from self-help books to erotica” from the celebrated Canadian author (<i>The Chronicle Journal</i>).</b><br/>  <br/> An urbane, robust, and wonderfully opinionated voice from Canada, sometimes called “America’s attic,” speaks here of the delights of reading, and of what mass education has done to readers today, to taste, to books, to culture. With his usual wit and breadth of vision, Robertson Davies ranges through the world of letters—books renowned and obscure, old and recent; English, Irish, Canadian, and American writers both forgotten and fondly remembered.<br/>  <br/> “Sweet reason in the raiment of well-woven prose? Most assuredly. Good humor agraze over broad literary demesnes? No doubt of it. Forgotten popular favorites rescued and rehabilitated? Certainly. A parade of agreeable prejudices? He would not be a true Canadian if he did not have them. Lightheartedness where needed? Yes. Seriousness where it counts? Yes. Wit, satirical touches, firm indignations, sound sense, good taste, judiciousness, cosmopolitan breadth of view, urbanity, sanity, unexpected eccentricities, educated humanism? By all means. It is indeed by all these means and more that this book of essays and observations bestows its multiple benefactions, and anyone picking it up is bound north to pleasure and profit.”—<i>The New York Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robertson Davies
      </h2>
      
      <p class="authorDescription body article">Robertson Davies (1913&ndash;1995) was born and raised in Ontario, and was educated at a variety of schools, including Upper Canada College, Queen&rsquo;s University, and Balliol College, Oxford. He had three successive careers: as an actor with the Old Vic Company in England; as publisher of the Peterborough Examiner; and as university professor and first Master of Massey College at the University of Toronto, from which he retired in 1981 with the title of Master Emeritus. He was one of Canada&rsquo;s most distinguished men of letters, with several volumes of plays and collections of essays, speeches, and <I>belles lettres</I> to his credit. As a novelist, he gained worldwide fame for his three trilogies: <I>The Salterton Trilogy</I>, <I>The Deptford Trilogy</I>, and <I>The Cornish Trilogy</I>, and for later novels <I>Murther and Walking Spirits</I> and <I>The Cunning Man</I>. His career was marked by many honors: He was the first Canadian to be made an Honorary Member of the American Academy of Arts and Letters, he was a Companion of the Order of Canada, and he received honorary degrees from twenty-six American, Canadian, and British universities.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7ac34701